import React from 'react';
import { FiLoader } from 'react-icons/fi';
import { getLanguageTexts, getSelectedLanguage } from '../languages';

const Loader = ({ title, description, compact = false }) => {
    const t = getLanguageTexts(getSelectedLanguage());
    const loaderTitle = title || t.loading_data || 'Carregando dados';
    const loaderDescription = description === undefined ? (t.loading_hint || 'Aguarde enquanto preparamos as informações.') : description;

    return (
        <div className={`correcao-loader ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
            <span className="correcao-loader-icon" aria-hidden="true">
                <FiLoader />
            </span>
            <span className="correcao-loader-copy">
                <strong>{loaderTitle}</strong>
                {loaderDescription && <small>{loaderDescription}</small>}
            </span>
        </div>
    );
};

export default Loader;
